export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Download Our App",
  headline: "Access from anywhere",
  description:
    "Get access to our exlusive app that allwos you to be with you coaches from anywhere.",
  buttonLabel: "Download",
  imgStart: false,
  img: require("../../images/svg-6.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
  link:"home",
  bgImg:require("../../images/Val-Bg.jpg").default

  

};

export const homeObjTwo = {
  id: "coaching",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Book Your Session",
  headline: "ONE-ON-ONE COACHING",
  description:
    "Skill-Assesment, Gameplay Review, and more...",
  buttonLabel: "Book Now!",
  imgStart: true,
  img: require("../../images/Coach.jpg").default,
  alt: "bank",
  dark: false,
  primary: false,
  darkText: true,
  link:"home",

};



export const homeObjFour = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join Us",
  headline: "Creating account is free and easy",
  description:
    "Get access to our free trial and more with our premuim plan.",
  buttonLabel: "Sign Up",
  imgStart: false,
  img: require("../../images/valorant-agent-sova-full-body.png").default,
  alt: "Papers",
  dark: false,
  primary: false,
  darkText: true,
  link:"home",


};
